<template lang="pug">
  .flow-builder-view-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform, platform_index) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white.mb-3
        p.mb-0 AI - NLP
        p.text-secondary.text-sm Te permite detectar intenciones (acciones) y/o entidades (datos relevantes) en el mensaje del usuario.
        p.text-help.text-sm Solo se ejecuta el conector si se detectan las intenciones y/o entidades definidas.
        fieldset(:disabled="disabled")
          b-form-group(v-for="(template_attribute, template_attribute_index) in Template_Attributes", :key="template_attribute_index", v-if="template_attribute.name == 'intent_confidence'")
            p.mb-2 Precisión en intenciones: {{ Math.floor(parseFloat(template_attribute.value) * 100) }}%
              span.ml-2.text-primary.text-sm(v-if="intent_confidence") Nuevo valor: {{ Math.floor(intent_confidence * 100) }}%
            b-form-input(type="range", min="0", max="1", step="0.01", :value="template_attribute.value", @input="intent_confidence = $event", @change="updateTemplateAttribute(template_attribute, $event)")
          b-form-group.mb-3(v-for="(template_attribute, template_attribute_index) in Template_Attributes", :key="template_attribute_index", v-if="template_attribute.name == 'entity_confidence'")
            p.mb-2 Precisión en entidades: {{ Math.floor(parseFloat(template_attribute.value) * 100) }}%
              span.ml-2.text-primary.text-sm(v-if="entity_confidence") Nuevo valor: {{ Math.floor(entity_confidence * 100) }}%
            b-form-input(type="range", min="0", max="1", step="0.01", :value="template_attribute.value", @input="entity_confidence = $event", @change="updateTemplateAttribute(template_attribute, $event)")
      ai-nlp-element(v-for="(element, element_index) in Elements", :key="element_index", v-if="element.type == 'intent_validation'", :id="`element_${element.element_id}`", :disabled="disabled", :block_id="block_id", v-bind="element", @destroy="destroyTemplateElement(element)")
      add-element-button(v-if="!disabled", @click="createTemplateElement", title="Agregar modelo")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import templateCommon from '@/helpers/template-common'
import AINLPElement from '@/components/templates/AINLPElement.vue'
import AddElementButton from '@/components/AddElementButton.vue'
import TemplateTools from '@/components/templates/common/Tools.vue'
import _debounce from 'lodash.debounce'

const accountController = createNamespacedHelpers('account')

export default {
  mixins: [templateCommon],
  data () {
    return {
      intent_confidence: null,
      intent_confidence_to: null,
      entity_confidence: null,
      entity_confidence_to: null,
      models: []
    }
  },
  methods: {
    ...mapActions(['account/userAttributes', 'model/all']),
    getModels () {
      const self = this

      this['model/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) return this.$message.error(res.error)
        }
      })
    },
    getUserAttributes () {
      const self = this

      this['account/userAttributes']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) return this.$message.error(res.error)
        }
      })
    },
  },
  computed: {
    ...accountController.mapState({
      user_attributes: state => state.user_attributes
    })
  },
  components: {
    'ai-nlp-element': AINLPElement,
    AddElementButton,
    TemplateTools
  },
  mounted () {
    this.getModels()
    this.getUserAttributes()
  },
  created () {
    this.updateTemplateAttribute = _debounce((template_attribute, value) => {
      const attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value

      this.updateAttribute(this.block_id, this.template_id, attribute).then(() => {
        this.$message.success('Actualizado')
      })
    }, 100, { leading: false, trailing: true })

    this.createTemplateElement = () => {
      let self = this
      let element = {
        type: 'intent_validation',
        number: self.Elements.length + 1,
        attributes: [
          {
            name: 'model_id',
            value: ''
          },
          {
            name: 'intent',
            value: ''
          },
          {
            name: 'entities',
            value: []
          }
        ],
        connectors: [
          {
            element_id: self.template_id,
            next_block_id: self.block_id,
            type: 'intent_validation'
          }
        ]
      }

      this.createElement(this.block_id, this.template_id, element)
    }

    this.destroyTemplateElement = (element) => {
      this.destroyElement(this.block_id, this.template_id, element)
    }
  },
  watch: {
    intent_confidence (value) {
      clearTimeout(this.intent_confidence_to)
      if (value != undefined) {
        this.intent_confidence_to = setTimeout(() => {
          this.intent_confidence = null
        }, 1000);
      }
    },
    entity_confidence (value) {
      clearTimeout(this.entity_confidence_to)
      if (value != undefined) {
        this.entity_confidence_to = setTimeout(() => {
          this.entity_confidence = null
        }, 1000);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .flow-builder-view-template {
    position: relative;
    flex: 1 0 auto;
    max-width: 100%;
    background-color: transparent;
    white-space: normal;
  }
</style>
